export default "__VITE_ASSET__CMLtd4OT__"